<template>
  <v-app style="background: rgba(0,0,0,0);">
    <v-container>
      <v-layout align-center grid-list-md text-xs-center>
        <v-flex
          xs12
          sm10
          md8
          lg8
          v-if="!start"
          class="main"
          style="margin:0 auto"
        >
          <div class="title">
            <h1>OXFORD PERSÖNLICHKEITSTEST</h1>
          </div>
          <v-card color="primary">
            <v-card-title primary-title class="justify-center ma-5 maintitle">
              <div class="display-1 font-weight-bold white--text">
                Sind Sie neugierig über sich selbst?
              </div>
            </v-card-title>
            <v-card>
              <v-card-text class="headline font-weight-medium">
                <div class="subheading my-3">
                  <h3>Was sind Ihre Stärken?</h3>
                  <h3>Was sind Ihre Schwächen?</h3>
                  <h3>Was hält Sie zurück?</h3>
                </div>
              </v-card-text>
              <div class="font-weight-medium" style="text-align: center">
                <h2 class="findouttext">
                  Füllen Sie den Persönlichkeitstest aus!
                </h2>
              </div>
              <div
                class="introsection2 font-weight-medium"
                style="text-align: center"
              >
                <h2>
                  UM DEN TEST AUSZUFÜLLEN, KÖNNEN SIE AUCH DIE ZAHLEN 1, 2 UND 3
                  AUF DER TASTATUR BENUTZEN.
                </h2>
                <v-img
                  src="https://ocatestcenter.de/oca-instructions.png"
                  aspect-ratio="2.85"
                ></v-img>
              </div>
              <div class="ctasection">
                <v-form style="text-align:center">
                  <v-btn
                    style="width:90%"
                    color="primary"
                    @click="start = true"
                  >
                    Fange jetzt gleich an und fülle den Test aus!
                  </v-btn>
                </v-form>
              </div>
            </v-card>
          </v-card>
        </v-flex>

        <div class="logo"></div>

        <v-flex
          xs12
          sm10
          md8
          lg8
          v-if="start && questionNum < myJson.length"
          style="margin:0 auto"
          class="main"
        >
          <div class="title">
            <h1>OXFORD PERSÖNLICHKEITSTEST</h1>
          </div>
          <v-card color="primary">
            <div
              class="caption progress font-weight-light white--text"
              style="float:right"
            >
              {{ questionNum + 1 }}/{{ myJson.length }}
            </div>
            <v-card-title primary-title class="justify-center ma-5 questions">
              <div
                class="display-1 font-weight-light white--text"
                v-for="(data, index) in myJson.slice(
                  questionNum,
                  questionNum + 1
                )"
                v-bind:key="index"
              >
                {{ data }}
              </div>
            </v-card-title>
            <v-card-actions class="justify-space-around mt-5">
              <v-flex xs4>
                <v-card
                  :class="button1Color"
                  @mouseover="button1Color = 'light-green accent-1'"
                  @mouseleave="button1Color = 'white'"
                  @click="onkey({ key: '1' })"
                >
                  <!-- <v-card class="yesBtn button1Color" @click="onkey({key: '1'})"> -->
                  <v-card-text class="px-0">1-Ja</v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs4>
                <v-card
                  :class="button2Color"
                  @mouseover="button2Color = 'grey lighten-2'"
                  @mouseleave="button2Color = 'white'"
                  @click="onkey({ key: '2' })"
                >
                  <v-card-text class="px-0">2-Vielleicht</v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs4>
                <v-card
                  :class="button3Color"
                  @mouseover="button3Color = 'red lighten-2'"
                  @mouseleave="button3Color = 'white'"
                  @click="onkey({ key: '3' })"
                >
                  <v-card-text class="px-0">3-Nein</v-card-text>
                </v-card>
              </v-flex>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex
          xs12
          sm10
          md8
          lg8
          v-if="questionNum >= myJson.length"
          class="main"
          style="margin:0 auto"
        >
          <div class="title">
            <h1>OXFORD PERSÖNLICHKEITSTEST</h1>
          </div>
          <v-card color="primary">
            <v-card-title primary-title class="justify-center ma-5 maintitle">
              <div class="display-1 font-weight-bold white--text">
                Fast geschafft
              </div>
            </v-card-title>
          </v-card>

          <v-card class="contactform">
            <v-card-text class="headline font-weight-medium">
              <span
                >Für die Auswertung geben Sie bitte die folgenden Informationen
                an:</span
              >
              <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-container grid-list-xl text-xs-center fluid>
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md6 lg6 :class="{'pb-0': $vuetify.breakpoint.xs}">
                      <v-text-field
                        v-model="answers.vezeteknev"
                        label="Vorname"
                        :rules="nameRules"
                        required
                      ></v-text-field>

                     <v-text-field
                        v-model="answers.keresztnev"
                        label="Nachname"
                        :rules="nameRules"
                        required
                      ></v-text-field>

                      <v-select
                        :class="{'mt-2': $vuetify.breakpoint.xs}"
                        v-model="answers.nem"
                        :items="items"
                        solo
                        label="Geschlecht"
                        :rules="nemRules"
                      ></v-select>

                    </v-flex>

                    <v-flex xs12 sm6 md6 lg6 :class="{'pt-0': $vuetify.breakpoint.xs}">

                       <v-text-field
                        v-model="answers.telefonszam"
                        label="Telefonnummer"
                        :rules="phoneRules"
                        required
                      ></v-text-field>

                      <v-text-field
                        :class="{'mt-0': $vuetify.breakpoint.xs}"
                        v-model="answers.email"
                        label="E-mail"
                        :rules="emailRules"
                        required
                      ></v-text-field>

                      <v-text-field
                        v-model="answers.eletkor"
                        label="Alter"
                        :rules="ageRules"
                        required
                      ></v-text-field>


                    </v-flex>

                  </v-layout>
                </v-container>
                <v-checkbox
                  class="terms"
                  v-model="checkbox"
                  label="Ich stimme zu, dass die SKBW alle, von mir elektronisch zur Verfügung gestellten Daten vewalten,
                  speichern und mich telefonisch und/oder per E-Mail wegen der Testauswertung kontaktieren darf.
                  Diese Einwilligung kann jederzeit von mir per E-Mail widerrufen werden"
                  required
                ></v-checkbox>
                <p class="acceptance">
                  Weitere Informationen finden Sie im
                  <router-link :to="{ name: 'about' }" target="_blank"
                    >Datenschutzerklärung</router-link
                  >.
                </p>
                <span>{{ msg }}</span>
                <v-divider></v-divider>
                <v-btn
                  class="sendbutton"
                  :disabled="!checkbox || !this.$refs.form.value"
                  color="success"
                  @click="validate"
                  :loading="loading"
                >
                  Senden
                </v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <MyFooter />
  </v-app>
</template>

<script>
import json from "./realquestions.json";
import axios from "axios";
import MyFooter from "../components/footer.vue";
export default {
  data() {
    return {
      loading: false,
      myJson: json,
      start: false,
      // questionNum: 200,
      questionNum: 0,  // ezt kell az éles verzióban bent hagyni
      items: ["Herr", "Frau"],
      msg: "",
      checkbox: false,
      answers: {
        telefonszam: "",
        email: "",
        nev: "",
        vezeteknev: '',
        keresztnev: '',
        eletkor: "",
        nem: ""
      },
      button1Color: "white",
      button2Color: "white",
      button3Color: "white",
      valid: true,
      nameRules: [
        v => !!v || "Name ist eforderlich.",
        v => v.length >= 3 || "Bitte geben Sie Ihren vollständigen Namen an."
      ],
      phoneRules: [
        v => !!v || "Bitte geben Sie eine gültige Telefonnummer an.",
        v => v.length >= 5 || "Bitte geben Sie eine gültige Telefonnummer an."
      ],
      emailRules: [
        v => !!v || "Bitte geben Sie eine gültige E-Mail-Adresse an.",
        v =>
          /.+@.+/.test(v) || "Bitte geben Sie eine gültige E-Mail-Adresse an."
      ],
      ageRules: [
        v => !!v || "Bitte geben Sie ein gültiges Alter an.",
        v => parseInt(v) > 0 || "Bitte geben Sie ein gültiges Alter an."
      ],
      nemRules: [v => !!v || "Bitte wählen Sie Ihr Geschlecht"],
      lazy: false
    };
  },
  components: {
    MyFooter
  },
  created: function() {
    // window.addEventListener("keydown", this.onkey);
    window.addEventListener("keyup", this.onkey); // ezt kell az éles verzióban bent hagyni
  },
  beforeDestroy: function() {
    // window.removeEventListener("keydown", this.onkey);
    window.removeEventListener("keyup", this.onkey);  // ezt kell az éles verzióban bent hagyni
  },
  methods: {
    onkey(event) {
      let questNum = String(parseInt(this.questionNum) + 1);
      if (questNum == "200") {
        window.removeEventListener("keydown", this.onkey);
      } else if (parseInt(questNum) > 200) {
        return
      }
      switch (event.key) {
        case "1":
          this.button1Color = "light-green accent-1";
          this.answers["Q" + questNum] = "X00";
          break;
        case "2":
          this.button2Color = "grey lighten-2";
          this.answers["Q" + questNum] = "0X0";
          break;
        case "3":
          this.button3Color = "red lighten-3";
          this.answers["Q" + questNum] = "00X";
          break;
        default:
          return;
      }
      this.$forceUpdate();
      this.questionNum++;
      setTimeout(() => {
        this.button1Color = "white";
        this.button2Color = "white";
        this.button3Color = "white";
      }, 100);
    },
    validate() {
      var form_data = new FormData();
      // delete this.answers.email
      for (var key in this.answers) {
        form_data.append(key, this.answers[key]);
      }
      // let answers;
      let msg;
      // try {
      this.loading = true
      axios
        .post(
          "https://oca.denke-plus.de/oca/oxfordi_teszt_oca/kiertekelt.php",
          form_data
        )
        .then(response => {
          msg = "Valami baj van az adatok feldo";
          this.msg =
            "Vielen Dank für die Beantwortung der Fragen. Nach erfolgter Auswertung werden wir uns mit Ihnen in Verbindung setzen.";
          this.$router.push("wichtige-information");
          this.loading = false
        })
        .catch(function(error) {
          msg = "Valami hiba tortent";
          this.loading = false
        });
      // axios.get(`https://hooks.zapier.com/hooks/catch/2083855/onpvv1m?first_name=${this.answers.vezeteknev}&last_name=${this.answers.keresztnev}&phone=${this.answers.telefonszam}&origin=${this.name}&email=${this.answers.email}&gender=${this.answers.nem}&age=${this.answers.eletkor}&date=${new Date()}`)

      // } catch (e) {
      //   msg = "Valami hiba tortent"
      // } finally {
      //   this.answers = {
      //     telefonszam: '',
      //     email: '',
      //     nev: '',
      //     eletkor: '',
      //     nem: '',
      //   }
      // }
    }
  }
};
</script>

<style media="screen">
body {
  background-image: url(background.png);
  background-position: right top;
  background-repeat: no-repeat;
  background-attachment: fixed;
}
.container {
  display: table;
}
.logo {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-image: url(oca-logo.png);
  background-repeat: no-repeat;
  max-width: 250px;
  background-size: contain;
  margin-top: 10px;
  margin-left: 1.5%;
  height: 200px;
  width: 19vw;
}
.introsection2 {
  padding: 50px;
  margin-top: 30px;
  background: #f7f7f7;
}
.ctasection {
  padding: 15px;
}
.v-card {
  overflow: auto;
}
.v-card__title--primary {
  padding-top: 0px;
  padding-bottom: 0px;
}
.v-card__actions {
  padding: 0px;
  background: #fff;
  margin-top: 0px !important;
}
.v-card__actions .xs4 {
  flex-basis: 33.34% !important;
  max-width: 33.34% !important;
}
.v-card__actions .v-sheet {
  border-radius: 0px;
  -webkit-box-shadow: none;
  box-shadow: none;
  text-decoration: none;
}
.yesBtn:hover {
  background-color: rgb(205, 242, 202);
  cursor: pointer;
}
.maybeBtn:hover {
  background-color: rgb(208, 208, 208);
  cursor: pointer;
}
.noBtn:hover {
  background-color: rgb(255, 191, 177);
  cursor: pointer;
}
.main {
  box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.15);
  padding: 0;
}
.main .v-sheet {
  border-radius: 0px;
}
.title {
  font-size: 20px !important;
  line-height: 50px !important;
  text-align: left !important;
  padding-left: 20px;
  padding-right: 20px;
  background: #fff;
  font-weight: 400;
}
.title h1 {
  font-size: 20px !important;
  line-height: 50px !important;
  text-align: left !important;
  padding-left: 20px;
  padding-right: 20px;
  background: #fff;
  font-weight: 400;
}
.v-card__text {
  padding: 0;
  line-height: 50px;
}
.progress {
  border-radius: 0 0 0 15px;
  padding: 4px 30px 4px 35px;
  background: #006c9f;
  font-size: 15px !important;
  font-weight: 400 !important;
}
.contactform {
  padding: 40px;
}
.acceptance {
  font-size: 16px;
}
.sendbutton {
  margin-top: 25px;
}
.v-card__actions .v-card__text {
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.introsection2 h2 {
  text-transform: uppercase;
  margin-bottom: 60px;
  font-weight: 800;
}
.questions {
  min-height: 45vh !important;
}

@media only screen and (max-width: 1024px) {
  .logo {
    display: none;
  }
}

@media only screen and (max-width: 768px) {
  .display-1 {
    font-size: 20px !important;
    line-height: 34px !important;
  }
  .questions {
    margin: 30px 20px !important;
  }
  .container .title h1 {
    font-size: 16px !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .v-btn {
    height: auto !important;
  }
  .v-btn__content {
    white-space: initial;
  }
  .maintitle {
    margin: 25px 25px !important;
  }
  .headline {
    font-size: 15px !important;
    line-height: 25px !important;
  }
  .v-label {
    font-size: 14px;
  }
  .terms .v-label {
    font-size: 10px;
    line-height: 1.6;
  }
  .terms .v-input__slot {
    align-items: initial;
  }
  .subheading {
    font-size: 15px !important;
  }
  .findouttext {
    font-size: 18px !important;
  }
  .introsection2 {
    padding-left: 15px;
    padding-right: 15px;
  }
  .introsection2 h2 {
    font-size: 16px;
  }
}
</style>
